// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ATQr","title":"styles_title__1UBNT"};